// extracted by mini-css-extract-plugin
export var btn = "z_mD t_rQ t_rv d_bw d_bL d_bz d_ds";
export var full = "z_ty d_s d_D";